import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRemix: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRemix"><Path d="M21 20H5.56055L7.28027 21.7197L6.21973 22.7803L2.68945 19.25L6.21973 15.7197L7.28027 16.7803L5.56055 18.5H19.5V11H21V20Z" fill="currentColor"/><Path d="M12.75 11.25H16V12.75H12.75V16H11.25V12.75H8V11.25H11.25V8H12.75V11.25Z" fill="currentColor"/><Path d="M21.3105 4.75L17.7803 8.28027L16.7197 7.21973L18.4395 5.5H4.5V13H3V4H18.4395L16.7197 2.28027L17.7803 1.21973L21.3105 4.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRemix;
